import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";

import logo from "../image/USA_transparent (2).png"; // Add your logo here
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdmissionsPage = () => {
    useEffect(() => {
      const NUM_BALLS = 18;
      const balls = [];
      const colors = [
        "#f1f5ff", // very light blue
        "#a5b4fc", // soft indigo
        "#fcd34d", // soft yellow
        "#fca5a5", // soft red
        "#6ee7b7", // soft green
        "#f9a8d4", // soft pink
        "#c7d2fe", // blue-gray
        "#fff"
      ];
      const container = document.getElementById("randomBallsBg");
      if (!container) return;
      container.innerHTML = "";
      const footer = document.querySelector("footer");
      let footerHeight = 0;
      if (footer) {
        footerHeight = footer.offsetHeight;
      }
      const W = window.innerWidth;
      const H = window.innerHeight - footerHeight;
      for (let i = 0; i < NUM_BALLS; i++) {
        const ball = document.createElement("div");
        const size = Math.random() * 18 + 12;
        ball.className = "random-ball";
        ball.style.width = `${size}px`;
        ball.style.height = `${size}px`;
        ball.style.background = colors[Math.floor(Math.random() * colors.length)];
        ball.style.left = `${Math.random() * (W - size)}px`;
        ball.style.top = `${Math.random() * (H - size)}px`;
        container.appendChild(ball);
        balls.push({
          el: ball,
          x: parseFloat(ball.style.left),
          y: parseFloat(ball.style.top),
          dx: (Math.random() - 0.5) * 1.5,
          dy: (Math.random() - 0.5) * 1.5,
          size,
        });
      }
      let running = true;
      function animate() {
        if (!running) return;
        for (const b of balls) {
          b.x += b.dx;
          b.y += b.dy;
          if (b.x < 0 || b.x > W - b.size) b.dx *= -1;
          if (b.y < 0 || b.y > H - b.size) b.dy *= -1;
          b.x = Math.max(0, Math.min(W - b.size, b.x));
          b.y = Math.max(0, Math.min(H - b.size, b.y));
          b.el.style.transform = `translate(${b.x}px, ${b.y}px)`;
        }
        requestAnimationFrame(animate);
      }
      animate();
      return () => {
        running = false;
        if (container) container.innerHTML = "";
      };
    }, []);
  const [formData, setFormData] = useState({
    fullName: "",
    batch: "",
    stream: "",
    medium: "",
    subjects: [],
    address: "",
    nic: "",
    mobile: "",
    email: "",
    remarks: "",
    dayBatch: false, // Optional Day batch checkbox
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({ nic: '', mobile: '' });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubjectsChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      subjects: checked
        ? [...prev.subjects, value]
        : prev.subjects.filter((subject) => subject !== value),
    }));
  };

  const validateNIC = (nic) => {
    // Old format: 9 digits + V/v/X/x, New format: 12 digits
    return /^\d{9}[vVxX]$/.test(nic) || /^\d{12}$/.test(nic);
  };

  const validateMobile = (mobile) => {
    // Sri Lankan mobile: 10 digits, starts with 07
    return /^07\d{8}$/.test(mobile);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let valid = true;
    let newErrors = { nic: '', mobile: '' };

    if (!validateNIC(formData.nic)) {
      newErrors.nic = 'Invalid NIC number (e.g., 123456789V or 200012345678)';
      valid = false;
    }
    if (!validateMobile(formData.mobile)) {
      newErrors.mobile = 'Invalid Sri Lankan mobile number (should start with 07 and have 10 digits)';
      valid = false;
    }
    setErrors(newErrors);
    if (!valid) {
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);
    const emailParams = {
      ...formData,
      subjects: formData.subjects.join(", "),
      email: formData.email || "N/A",
      remarks: formData.remarks || "N/A",
    };

    emailjs
      .send(
        "service_rc6rard", // Updated EmailJS Service ID
        "template_nibkked", // Your EmailJS Template ID
        emailParams,
        "YB_0Cnu18PoH_121o" // Updated EmailJS Public Key
      )
      .then(() => {
        toast.success("🎉 Registration Successful! Confirmation email sent.");
        setFormData({
          fullName: "",
          batch: "",
          stream: "",
          medium: "",
          subjects: [],
          address: "",
          nic: "",
          mobile: "",
          email: "",
          remarks: "",
        });
        setErrors({ nic: '', mobile: '' });
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        toast.error("❌ Registration failed. Please try again.");
        setIsSubmitting(false);
      });
  };

  return (
    <div className="relative min-h-screen flex flex-col items-center p-4 bg-lightblue overflow-hidden">
      {/* Animated Random Balls Background */}
      <div className="random-balls-bg" id="randomBallsBg"></div>
      <ToastContainer />


    {/* Form Card */}
<div
  className="relative z-[100] bg-white p-8 rounded-xl shadow-2xl w-full max-w-5xl"
  style={{
    position: "relative",
    pointerEvents: "auto",
  }}
>
<div className="relative flex bg-primary justify-center shadow-md mb-6 rounded-lg p-4 rounded-lg ">
  
  <img src={logo} alt="Logo" className="h-32" />
  <h2 className="text-5xl mt-10 font-bold text-white">Admission Form</h2>
</div>
  {/* Removed absolute overlay div to prevent covering the form */}

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left Column */}
          <div className="space-y-4">
            <div>
              <label className="block font-medium mb-1">Full Name:</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter your full name"
                autoComplete="off"
                required
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#002E63]"
              />
            </div>

            <div>
              <label className="block font-medium mb-1">Address:</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter your address"
                autoComplete="off"
                required
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#002E63]"
              />
            </div>

            <div>
              <label className="block font-medium mb-1">NIC:</label>
              <input
                type="text"
                name="nic"
                value={formData.nic}
                onChange={handleChange}
                placeholder="e.g. 123456789V or 200012345678"
                autoComplete="off"
                required
                className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#002E63] placeholder:opacity-60 ${errors.nic ? 'border-red-500' : ''}`}
              />
              {errors.nic && <p className="text-red-500 text-sm mt-1">{errors.nic}</p>}
            </div>

            <div>
              <label className="block font-medium mb-1">Mobile:</label>
              <input
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="e.g. 0712345678"
                autoComplete="off"
                required
                className={`w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#002E63] placeholder:opacity-60 ${errors.mobile ? 'border-red-500' : ''}`}
              />
              {errors.mobile && <p className="text-red-500 text-sm mt-1">{errors.mobile}</p>}
            </div>

            <div>
              <label className="block font-medium mb-1">Email (Optional):</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email address"
                autoComplete="off"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#002E63]"
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-4">
            {/* Batch */}
            <div>
              <label className="block font-medium mb-2">Batch:</label>
              <div className="flex flex-wrap gap-4">
                {["2026 A/L", "2027 A/L", "2028 A/L"].map((option) => (
                  <label key={option} className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="batch"
                      value={option}
                      checked={formData.batch === option}
                      onChange={handleChange}
                      required
                    />
                    <span>{option}</span>
                  </label>
                ))}
                {/* Optional Day batch checkbox */}
                <label className="flex items-center space-x-2 ml-4">
                  <input
                    type="checkbox"
                    name="dayBatch"
                    checked={formData.dayBatch}
                    onChange={handleChange}
                  />
                  <span>Day batch (optional)</span>
                </label>
              </div>
            </div>

            {/* Stream */}
            <div>
              <label className="block font-medium mb-2">Stream:</label>
              <div className="flex flex-wrap gap-4">
                {["Bio", "Maths"].map((option) => (
                  <label key={option} className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="stream"
                      value={option}
                      checked={formData.stream === option}
                      onChange={handleChange}
                      required
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Medium */}
            <div>
              <label className="block font-medium mb-2">Medium:</label>
              <div className="flex flex-wrap gap-4">
                {["English", "Tamil"].map((option) => (
                  <label key={option} className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="medium"
                      value={option}
                      checked={formData.medium === option}
                      onChange={handleChange}
                      required
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Subjects */}
            <div>
              <label className="block font-medium mb-2">Subjects:</label>
              <div className="flex flex-wrap gap-4">
                {["Physics", "Chemistry"].map((subject) => (
                  <label key={subject} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      value={subject}
                      checked={formData.subjects.includes(subject)}
                      onChange={handleSubjectsChange}
                    />
                    <span>{subject}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Remarks */}
            <div>
              <label className="block font-medium mb-1">Remarks (Optional):</label>
              <textarea
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
                placeholder="Enter any other remarks"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#002E63]"
                autoComplete="off"
                rows="3"
              ></textarea>
            </div>
          </div>

          {/* Submit button full width */}
          <div className="col-span-1 md:col-span-2">
            <button
              type="submit"
              className="w-full bg-[#002E63] text-white py-3 rounded-lg text-lg font-semibold hover:bg-[#001C3D] transition duration-300"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Register"}
            </button>
          </div>
        </form>
      </div>
      {/* <div class="mt-16 ">

    </div> */}
    </div>

    
  );
};

export default AdmissionsPage;
